import { Link } from "react-router-dom";
import { MapPin, Phone, MessageCircle, Mail } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { mediaUrl, telHref, waHref } from "@/lib/api";
import { SocialLinks, WorkingHours } from "@/components/site/Social";
const LEGAL = [
  ["/kvkk-aydinlatma-metni", "KVKK Aydınlatma Metni"],
  ["/gizlilik-politikasi", "Gizlilik Politikası"],
  ["/cerez-politikasi", "Çerez Politikası"],
  ["/kullanim-kosullari", "Kullanım Koşulları"],
];

function Col({ title, children }) {
  return (
    <div>
      <h3 className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-white">{title}</h3>
      <ul className="space-y-2.5 text-sm text-zinc-400">{children}</ul>
    </div>
  );
}

export function Footer() {
  const { settings: s, services } = useSite();
  return (
    <footer className="border-t-4 border-[color:var(--red)] bg-[color:var(--ink)] pb-24 text-zinc-400 lg:pb-0" data-testid="site-footer">
      <div className="container-x grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src={mediaUrl(s.logo_alt) || "/assets/logo-columns.webp"} alt="Rüzgar Savunma ve Özel Güvenlik logosu" className="h-20 w-auto rounded" loading="lazy" />
          <p className="mt-4 text-sm font-semibold text-white">{s.legal_name}</p>
          <p className="mt-2 text-sm">Kuşadası ve Ege Bölgesi'nde profesyonel özel güvenlik hizmetleri.</p>
          <div className="mt-5"><SocialLinks testid="footer-social" /></div>
        </div>
        <Col title="Hizmetlerimiz">
          {services.slice(0, 8).map((sv) => (
            <li key={sv.slug}><Link to={`/hizmetler/${sv.slug}`} className="transition-colors hover:text-white">{sv.title}</Link></li>
          ))}
        </Col>
        <Col title="Kurumsal">
          {[["/hakkimizda", "Hakkımızda"], ["/sektorler", "Sektörler ve Bölgeler"], ["/kalite-ve-guvenlik", "Kalite ve Güvenlik"], ["/kariyer", "Kariyer"], ["/blog", "Bilgi Merkezi"], ["/sikca-sorulan-sorular", "Sıkça Sorulan Sorular"], ["/teklif-al", "Teklif Al"], ["/operasyon/giris", "Personel / Müşteri Girişi"]].map(([to, l]) => (
            <li key={to}><Link to={to} className="transition-colors hover:text-white">{l}</Link></li>
          ))}
        </Col>
        <Col title="İletişim">
          <li className="flex gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--red)]" /><span>{s.address}</span></li>
          <li><a href={telHref(s.phone)} className="flex gap-2 hover:text-white" data-testid="footer-phone"><Phone className="h-4 w-4 text-[color:var(--red)]" />{s.phone}</a></li>
          <li><a href={waHref(s)} target="_blank" rel="noopener noreferrer" className="flex gap-2 hover:text-white" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-[color:var(--red)]" />WhatsApp ile yazın</a></li>
          {s.email && <li><a href={`mailto:${s.email}`} className="flex gap-2 hover:text-white" data-testid="footer-email"><Mail className="h-4 w-4 text-[color:var(--red)]" />{s.email}</a></li>}
          <li className="pt-2"><WorkingHours dark /></li>
        </Col>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-3 py-5 text-xs md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {s.legal_name}. Tüm hakları saklıdır.</p>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {LEGAL.map(([to, l]) => <Link key={to} to={to} className="hover:text-white">{l}</Link>)}
            <button onClick={() => window.dispatchEvent(new Event("open-cookie-prefs"))} className="hover:text-white" data-testid="footer-cookie-prefs">Çerez Tercihleri</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
